import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

import { brandShopUrlPrefix, retailersUrlPrefix } from 'app/retailer-platform/brand-shop/utils';
import { ContentService } from '../../retailer-platform/content/content.service';

@Injectable()
export class PvhGuard {
    constructor(
        private router: Router,
        private contentService: ContentService
    ) {}

    public canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
        return this.contentService.getPvhBrand(route.params.brandId).pipe(
            map((pvhBrandId) => {
                if (!pvhBrandId) {
                    return true;
                }

                return this.router.parseUrl(
                    `${retailersUrlPrefix}/${brandShopUrlPrefix}/${pvhBrandId}/content/products/bulk-gtin-search`
                );
            })
        );
    }
}
